// extracted by mini-css-extract-plugin
module.exports = {"RowMargin":"RowMargin_jfwRp"};